import actionCreatorFactory from 'typescript-fsa';
import { Dispatch } from 'redux';

import { fetchCategorySubline as fetchCategorySublineService } from '@client/services/api/category-subline';
import { getGender } from '@client/redux/modules/customer/selectors';
import { RootState } from '@client/redux/types';

import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

type Data = Record<string, string[]>;

// TODO: clean up this code when we remove the abtest
export const setCategorySubline = actionCreator.async<Data, Data, Error>('FETCH_CATEGORY_SUBLINE');

// TODO: clean up this code when we remove the abtest
export const fetchCategorySubline = () => (dispatch: Dispatch, getState: () => RootState) => {
    const gender = getGender(getState());

    dispatch(setCategorySubline.started(null));

    return fetchCategorySublineService(gender)
        .then(data => {
            dispatch(setCategorySubline.done({ params: null, result: data }));
        })
        .catch(error => {
            dispatch(setCategorySubline.failed({ params: null, error }));
        });
};
